import { omit } from 'lodash';

export default {
    props: {
        event: {
            required: true,
            type: Object
        },

        value: {
            type: [Object, Array],
            default: null
        },

        options: {
            type: Object,
            default: () => ({})
        },

        model: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            acceptanceOptions: [
                { value: 'yes', label: this.$t('meetings.details.statuses.accepted') },
                { value: 'no', label: this.$t('meetings.details.statuses.declined') },
                { value: 'pending', label: this.$t('meetings.details.statuses.pending') },
            ],
            presenceOptions: [
                { value: 'attended', label: this.$t('meetings.details.presence.attended') },
                { value: 'no-show', label: this.$t('meetings.details.presence.no-show') },
                { value: 'pending', label: this.$t('meetings.details.presence.pending') },
            ],
        };
    },

    computed: {
        innerValue: {
            get() {
                const ensureValues = doc => {
                    if (doc && !doc.label && doc.fname && doc.lname) {
                        doc.label = [doc.fname, doc.lname].join(' ');
                    }
                    return doc;
                };
                return Array.isArray(this.value)
                    ? this.value.map(ensureValues)
                    : ensureValues(this.value);
            },

            set(value) {
                this.$emit('input', value);
            }
        },
    },

    watch: {
        $attrs: {
            immediate: true,
            handler() {
                this.attrs = omit({ ...this.$options.propsData, ...this.$attrs }, 'model', 'options');
            }
        },

        model: {
            immediate: true,
            deep: true,
            handler(model) {
                const getExclusions = model => {
                    if (this.options?.exclude && model.hasOwnProperty(this.options.exclude)) {
                        const modelField = model[this.options.exclude];

                        if (Array.isArray(modelField)) {
                            return modelField.map(person => person.fp_ext_id);
                        } else if (modelField?.fp_ext_id) {
                            return [modelField.fp_ext_id];
                        }
                    }
                    return [];
                };
                this.exclusions = getExclusions(model);
            }
        },

        value: {
            immediate: true,
            handler() {
                this.loadStatus();
            }
        },
    },

    methods: {
        getItemLabel(item) {
            if (!item) {
                return '';
            }

            return this.$utils.locales.getExtPickerDocLabel(item, this.emitKey, { ...this.options, locale: this.locale });
        },

        async loadStatus() {
            if (!this.options.status_script) {
                return;
            }

            try {
                if (this.loading || !this.model.fp_owner) return;
                this.loading = true;
                const params = {
                    id: this.model.fp_owner,
                    meeting_id: this.model._id
                };

                // Cache of 3 seconds to avoid multiple requests close to eachother
                const data = await this.$services.appScripts.callAppScriptCached(this.event._id, this.options.status_script, params, true, 3000);
                this.setStatuses(data);
            } catch (error) {
                console.error('[AttendeePicker] Error while loading status:', error);
            } finally {
                this.loading = false;
            }
        },

        setPersonAttendance(person, attendance) {
            this.setPersonStatus(person, 'attendance', attendance || 'pending');
        },

        setPersonPresence(person, presence) {
            this.setPersonStatus(person, 'presence', presence || 'pending');
        },

        setPersonStatus(person, statusName, status) {
            if (!person || person[statusName] === status) {
                return;
            }

            this.$set(person, statusName, status);
        },
    }
};
